import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPlusIcon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="7 7 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 11.0002L13 7.00024H11L11 11.0002H7V13.0002H11L11 17.0002H13L13 13.0002H17V11.0002L13 11.0002Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPlusIcon);
export default ForwardRef;
